import { useChartContext } from '../core/chart-context';
import { buildTicks } from '../core/scales';
import type { YAxisSide } from '../core/types';

export interface YAxisProps {
  /** Formats the tick value */
  format?: (value: number) => string;
  tickCount?: number;
  /** Which side to render on — `right` uses the right y-scale */
  side?: YAxisSide;
}

/** Value axis rendered as tick labels beside the drawing area. */
export const YAxis = ({ format, tickCount = 5, side = 'left' }: YAxisProps) => {
  const context = useChartContext();
  const scale = side === 'right' ? context.yScaleRight : context.yScale;
  if (!scale) return null;

  const isRight = side === 'right';
  const x = isRight ? context.dimensions.innerWidth + 8 : -8;

  return (
    <g data-slot={isRight ? 'chart-y-axis-right' : 'chart-y-axis'}>
      {buildTicks(scale, tickCount).map(tick => (
        <text
          key={tick}
          x={x}
          y={scale(tick)}
          dy='0.32em'
          textAnchor={isRight ? 'start' : 'end'}
          fontSize={12}
          fill='var(--color-foreground-muted)'
        >
          {format ? format(tick) : tick}
        </text>
      ))}
    </g>
  );
};

YAxis.displayName = 'YAxis';
